import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import type { AppState } from '../state.js'

export const TermsRoute:FunctionComponent<{ state:AppState }> =
function TermsRoute () {
    return html`<div class="route terms">
        <h2>Terms of Service</h2>
        <p class="legal-updated">Last updated: June 27, 2026</p>

        <p>
            By using this website and its free tools, you agree to these
            terms. If you do not agree, please do not use the site.
        </p>

        <h3>Educational use only</h3>
        <p>
            The tools and content on this site are provided for
            educational and informational purposes only and do not
            constitute legal or compliance advice. Consult a qualified
            professional for guidance on EPA Section 608 obligations
            specific to your situation.
        </p>

        <h3>No warranty</h3>
        <p>
            The site and tools are provided "as is" and "as available,"
            without warranties of any kind. Calculations and results may
            contain errors. Always verify any result before relying on
            it.
        </p>

        <h3>Acceptable use</h3>
        <p>
            Do not misuse the site, attempt to disrupt or overload it, or
            access it in any unlawful way.
        </p>

        <h3>Limitation of liability</h3>
        <p>
            To the fullest extent permitted by law, hvaclog is not liable
            for any damages arising from your use of, or inability to
            use, the site or its tools.
        </p>

        <h3>Changes to these terms</h3>
        <p>
            We may update these terms from time to time. Continued use of
            the site after changes take effect means you accept the
            updated terms.
        </p>

        <h3>Contact</h3>
        <p>
            Questions about these terms? Email
            ${' '}<a href="mailto:mail@hvaclogsystem.com">
                mail@hvaclogsystem.com</a>.
        </p>

        <p class="legal-note">
            This page is a general template provided for convenience and
            is not legal advice. Consult a qualified professional to
            confirm it fits your situation.
        </p>
    </div>`
}
